<template>
    <div class="card" v-bind:style="{'background': color}">
        <slot name="card-body"></slot>
    </div>
</template>
<script>

export default {
    name: 'card',
    props: {
        color: {
            type: String,
            default: "#232b63"
        }
    },
}

</script>

<style scoped>
.card {
    background: #232b63;
    margin: 10px 16px;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/card.vue